import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import './tabs-selector.scss';

type Props = {
    isActive?: boolean;
    'data-state'?: 'checked' | 'unchecked';
} & ComponentPropsWithRef<'button'>;
export const TabsSelectorTab = ({
    children,
    isActive,
    className,
    'data-state': dataState,
    ...props
}: Props) => {
    const active = isActive || dataState === 'checked';
    return (
        <button
            type="button"
            className={cn('tabs-selector__tab', active && 'tabs-selector__tab--active', className)}
            data-state={dataState}
            {...props}
        >
            {active && <Icon name="check" width={24} height={24} />}
            {children}
        </button>
    );
};
